import(/* webpackMode: "eager" */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/app/globals.css");
;
import(/* webpackMode: "eager" */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/node_modules/@mui/material-nextjs/esm/v13-appRouter/appRouterV13.js");
;
import(/* webpackMode: "eager" */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/node_modules/next/font/google/target.css?{\"path\":\"app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/src/components/ClientWidgets.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/src/components/GlobalErrorLogger.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/builds/skaiciuokles/atlyginimo-skaiciuokle/src/components/SkipLink.tsx");
